import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { getacademincAPi, createacademincAPi, uploadacademincAPi, deleteacademincApi } from "../../../ApiUrl";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,
};
// create academic
export const createacademic = createAsyncThunk('createacademic/academic', async (formData, { rejectWithValue }) => {
    try {
        const response = await axios.post(createacademincAPi, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updateacademic = createAsyncThunk('updateacademic/academic', async ({ selectedId, formData }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${uploadacademincAPi}/${selectedId}`, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get academic
export const getacademic = createAsyncThunk('getacademic/academic', async () => {
    try {
        const response = await axios.get(`${getacademincAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'academics' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete academic
export const deleteacademics = createAsyncThunk('deleteacademics/academic', async (academicid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deleteacademincApi}/${academicid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'academicid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const academicSlice = createSlice({
    name: 'academic',
    initialState: {
        academics: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create academic
            .addCase(createacademic.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createacademic.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(action.payload);
                }
                state.status = 'idle';

            })
            .addCase(createacademic.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //update academic
            .addCase(updateacademic.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateacademic.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(action.payload);
                }
                state.status = 'idle';

            })
            .addCase(updateacademic.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //getacademics
            .addCase(getacademic.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getacademic.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.academics = action.payload;
            })
            .addCase(getacademic.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete academics
            .addCase(deleteacademics.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteacademics.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.academics.data = state.academics.data.filter(academics => academics.academicid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deleteacademics.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default academicSlice.reducer;
